const imagingQuestions =[

    {label:"Date of imaging",
    controlType:"date",
    options:[ ],
    },

    {label:"Hospital where imaging performed:",
    controlType:"text",
    options:[ ],
    },

    {label:"Type of imaging:",
    controlType:"radio button",
    options:["X Ray" , "Ultrasound", "CT", "MRI", "Nuclear medicine"],
    },

    {label:"Cancer on imaging:",
    controlType:"radio button",
    options:["Strong probability of cancer" , "Possibility of cancer", "Can't exclude cancer", "No suspicion of cancer"],
    },


    {label:"Summary of findings",
    controlType:"text area",
    options:[ ],
    },
    
]


export default imagingQuestions